export default function AppDownload() {
  return (
    <section id="app" className="relative py-20 md:py-28 px-4 md:px-8 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-10 md:gap-16">
          <div className="w-full md:w-1/2 flex flex-col items-start gap-5">
            <span className="inline-flex items-center gap-1.5 px-3.5 py-1.5 bg-accent-500/15 text-accent-400 text-xs font-semibold rounded-full border border-accent-500/20 whitespace-nowrap">
              <i className="ri-smartphone-line text-xs"></i>
              随时随地吃瓜
            </span>

            <h2 className="text-3xl md:text-4xl font-extrabold text-foreground-50 leading-tight tracking-tight">
              下载 <span className="font-heading italic text-accent-400">51爆料网</span> APP
            </h2>

            <p className="text-sm md:text-base text-foreground-400 leading-relaxed max-w-md">
              手机端专属优化体验，推送通知实时提醒最新爆料。支持iOS与Android双平台，随时随地掌握吃瓜第一手资讯，不错过任何一个劲爆瞬间。
            </p>

            <div className="flex items-center gap-3 pt-2">
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-950 font-semibold text-sm rounded-full hover:bg-accent-400 transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-apple-fill text-base"></i>
                iOS 下载
              </a>
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-6 py-3 border border-foreground-300/30 text-foreground-200 font-medium text-sm rounded-full hover:border-accent-500/50 hover:text-accent-400 transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-android-fill text-base"></i>
                Android 下载
              </a>
            </div>
          </div>

          <div className="w-full md:w-1/2 flex justify-center relative">
            <div className="relative w-64 h-[480px] rounded-[32px] border-2 border-background-300 bg-background-100 overflow-hidden transform md:-rotate-3 transition-transform hover:rotate-0 duration-500">
              <div className="absolute top-0 left-0 right-0 h-8 bg-background-200 rounded-t-[30px] flex items-center justify-center">
                <div className="w-20 h-1.5 bg-background-400 rounded-full"></div>
              </div>
              <div className="pt-10 px-4 h-full overflow-hidden">
                <div className="bg-background-50 rounded-2xl p-4 mb-3">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="w-8 h-8 rounded-lg bg-accent-500 flex items-center justify-center">
                      <i className="ri-flashlight-fill text-background-950 text-xs"></i>
                    </span>
                    <span className="text-foreground-200 font-bold text-xs">51爆料网</span>
                  </div>
                  <div className="space-y-2">
                    <div className="h-2 bg-background-200 rounded-full w-3/4"></div>
                    <div className="h-2 bg-background-200 rounded-full w-full"></div>
                    <div className="h-2 bg-background-200 rounded-full w-1/2"></div>
                  </div>
                </div>
                <div className="space-y-2">
                  {[1, 2, 3, 4].map((n) => (
                    <div key={n} className="bg-background-50 rounded-xl p-3 flex items-center gap-3">
                      <span className="w-2 h-2 rounded-full bg-accent-500 flex-shrink-0"></span>
                      <div className="flex-1">
                        <div className="h-1.5 bg-background-200 rounded-full w-4/5 mb-1.5"></div>
                        <div className="h-1 bg-background-200/60 rounded-full w-2/3"></div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}